import React from 'react';
import Slider from 'react-slick';
import fire from '../images/icons/fire.svg';
import voice from '../images/icons/voice.svg';
import paging from '../images/icons/paging.svg';
import security from '../images/icons/security.svg';
import audio from '../images/icons/audio.svg';
import access from '../images/icons/access.svg';
import telephony from '../images/icons/telephony.svg';
import PrevArrow from './PrevArrow';
import NextArrow from './NextArrow';

export const slides = [
  {
    id: 1,
    title: `Fire Alarms\n& Life Safety`,
    icon: fire,
    bgImage: {
      xs: 'bg-fire-xs',
      md: 'bg-fire-md',
      lg: 'bg-fire-lg',
      '2xl': 'bg-fire-2xl',
      '3xl': 'bg-fire-3xl',
    },
    bgColor: 'bg-techsicoRed-500',
    bgOpacity: 'bg-opacity-100',
    slug: 'fire-alarms-safety',
    value: 'Fire',
    iconClassName: 'h-8 w-6 2xl:h-10 2xl:w-8 3xl:h-12 3xl:w-9',
  },
  {
    id: 2,
    title: `Voice\n& Data`,
    icon: voice,
    bgImage: {
      xs: 'bg-voice-xs',
      md: 'bg-voice-md',
      lg: 'bg-voice-lg',
      '2xl': 'bg-voice-2xl',
      '3xl': 'bg-voice-3xl',
    },
    bgColor: 'bg-techsicoBlue-700',
    bgOpacity: 'bg-opacity-100',
    slug: 'voice-data',
    value: 'Voice Data',
    iconClassName:
      'h-5 w-7.5 md:h-5.5 md:w-8 lg:h-6 lg:w-9 2xl:h-8 2xl:w-12 3xl:h-9 3xl:w-12',
  },
  {
    id: 4,
    title: `Security &\nSurveillance\nSolutions`,
    icon: security,
    bgImage: {
      xs: 'bg-security-xs',
      md: 'bg-security-md',
      lg: 'bg-security-lg',
      '2xl': 'bg-security-2xl',
      '3xl': 'bg-security-3xl',
    },
    bgColor: 'bg-gray-500',
    bgOpacity: 'bg-opacity-100',
    slug: 'security-surveillance-solutions',
    value: 'Security',
    iconClassName: 'h-6 w-7 lg:h-8 lg:w-9.2 3xl:h-9 3xl:w-10',
  },
  {
    id: 3,
    title: `Paging,\nIntercom,\n& Clocks`,
    icon: paging,
    bgImage: {
      xs: 'bg-paging-xs',
      md: 'bg-paging-md',
      lg: 'bg-paging-lg',
      '2xl': 'bg-paging-2xl',
      '3xl': 'bg-paging-3xl',
    },
    bgColor: 'bg-enterpriseOrange-500',
    bgOpacity: 'bg-opacity-100',
    slug: 'paging-intercom-clocks',
    value: 'Telephones',
    iconClassName: 'h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8 3xl:h-9 3xl:w-9',
  },
  {
    id: 6,
    title: 'Access\nControl',
    icon: access,
    bgImage: {
      xs: 'bg-access-xs',
      md: 'bg-access-md',
      lg: 'bg-access-lg',
      '2xl': 'bg-access-2xl',
      '3xl': 'bg-access-3xl',
    },
    bgColor: 'bg-wirelessGreen-700',
    bgOpacity: 'bg-opacity-100',
    slug: 'access-control',
    value: 'Security',
    iconClassName:
      'h-5.25 w-7 md:h-4.5 md:w-6 lg:h-5 lg:w-7 2xl:h-6 2xl:w-8 3xl:h-7.5 3xl:w-10',
  },
  {
    id: 5,
    title: 'Audio/Video',
    icon: audio,
    bgImage: {
      xs: 'bg-audio-xs',
      md: 'bg-audio-md',
      lg: 'bg-audio-lg',
      '2xl': 'bg-audio-2xl',
      '3xl': 'bg-audio-3xl',
    },
    bgColor: 'bg-gray-500',
    bgOpacity: 'bg-opacity-100',
    slug: 'audio-video',
    value: 'Audio Video',
    iconClassName:
      'h-5 md:h-4.75 lg:h-5 lg:w-9 2xl:h-6 2xl:w-11 3xl:h-8 3xl:w-14.8',
  },  
  {
    id: 7,
    title: `Telephony\n& Network\nEngineering`,
    icon: telephony,
    bgImage: {
      xs: 'bg-telephony-xs',
      md: 'bg-telephony-md',
      lg: 'bg-telephony-lg',
      '2xl': 'bg-telephony-2xl',
      '3xl': 'bg-telephony-3xl',
    },
    bgColor: 'bg-techsicoBlue-800',
    bgOpacity: 'bg-opacity1200',
    slug: 'telephony-network',
    value: 'Telephones',
    iconClassName: 'h-6 w-5.5 lg:h-7 lg:w-6 2xl:h-8 2xl:w-7 3xl:h-9 3xl:w-7.5',
  },
];

const ServiceCarousel = ({
  showArrows = true,
  arrowPlacement = 'topLeft',
  autoplay = true,
  slidesToShow = 1,
  height = 'h-full',
  className,
  children,
}) => {
  // const { isMd, isLg, is2xl, is3xl } = useBreakpoints();

  React.useEffect(() => {
    document.querySelectorAll('.slick-slide').forEach(slide => {
      const TAILWIND_UNIT_TO_PX = 4;
      // e.g., slide.style.height = is3xl ? '360px' : is2xl ? '288px' : isLg ? '176px' : isMd ? '132px' : '172px';
      slide.style.height = `${(
        Number(height.replace('h-', '')) * TAILWIND_UNIT_TO_PX
      ).toString()}px`;
    });
  }, [height]);

  return (
    <Slider
      dots={false}
      slidesToShow={slidesToShow}
      swipeToSlide
      autoplay={autoplay}
      autoplaySpeed={4000}
      pauseOnHover
      prevArrow={showArrows ? <PrevArrow placement={arrowPlacement} /> : null}
      nextArrow={showArrows ? <NextArrow placement={arrowPlacement} /> : null}
      draggable={false}
      className={className}
    >
      {children}
    </Slider>
  );
};

export default ServiceCarousel;
